import { useQuery } from "@tanstack/react-query";
import { Copy, Crown, Link2, UsersRound } from "lucide-react";
import { SecondaryButton, StatusPill } from "@ocs/ui";
import { adminApi } from "../api";
import { amount } from "../format";
import { buildInviteLink } from "../config";

type Genesis = {
  user_address: string; account_type: number; referral_code: string | null; code_status: number | null;
  created_at: string | null; bound_count: string; qualified_count: string | null; total_direct_reward: string;
};

export function GenesisPage() {
  const query = useQuery({ queryKey: ["genesis"], queryFn: () => adminApi<Genesis | null>("/genesis-referrer"), refetchInterval: 5000 });
  const data = query.data;
  const inviteLink = data?.referral_code ? buildInviteLink(data.referral_code) : null;
  return (
    <div className="genesis-page">
      <section className="genesis-identity">
        <Crown />
        <div><p className="eyebrow">GENESIS REFERRER</p><h2>唯一创世推荐账户</h2><code>{data?.user_address ?? "0x3784adb01bb30929c7d74e7a1be8511fe4d6f598"}</code></div>
        <StatusPill tone="success">无需节点入金</StatusPill>
      </section>
      <section className="genesis-stats">
        <div><Link2 /><span>默认邀请码</span><strong>{data?.referral_code ?? "等待活动初始化"}</strong></div>
        <div><UsersRound /><span>绑定 / 有效入金</span><strong>{data?.bound_count ?? 0} / {data?.qualified_count ?? 0}</strong></div>
        <div><Crown /><span>累计直推奖励</span><strong>{amount(data?.total_direct_reward)} USDT</strong></div>
      </section>
      {inviteLink && (
        <section className="genesis-invite-link">
          <span>创世邀请链接</span>
          <code>{inviteLink}</code>
          <SecondaryButton onClick={() => navigator.clipboard.writeText(inviteLink)}><Copy size={16} />复制邀请链接</SecondaryButton>
        </section>
      )}
      <p className="boundary-note">这是 TP Wallet 多签合约地址，不具备普通 EOA 私钥。邀请码由系统迁移初始化，不能要求该地址完成 SIWE 登录。</p>
    </div>
  );
}
